// src/utils/scrollLock.js
let locked = false;
let prevOverflow = "";
let prevPaddingRight = "";
let scrollTopBefore = 0;

function getAppMain() {
  return document.querySelector(".app-main");
}

function getScrollbarWidth() {
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

export function lockAppScroll() {
  const el = getAppMain();
  if (!el || locked) return;

  locked = true;
  scrollTopBefore = el.scrollTop;

  // prevent layout shift if scrollbar appears/disappears (desktop)
  const sbw = getScrollbarWidth();
  prevPaddingRight = el.style.paddingRight;
  if (sbw) el.style.paddingRight = `${sbw}px`;

  prevOverflow = el.style.overflow;
  el.style.overflow = "hidden";

  // keep position stable
  el.scrollTop = scrollTopBefore;
}

export function unlockAppScroll() {
  const el = getAppMain();
  if (!el || !locked) return;

  locked = false;

  el.style.overflow = prevOverflow || "";
  el.style.paddingRight = prevPaddingRight || "";

  // restore scroll
  el.scrollTop = scrollTopBefore;
}
